import { render, staticRenderFns } from "./NotificationsArea.vue?vue&type=template&id=65689a36&scoped=true"
import script from "./NotificationsArea.vue?vue&type=script&lang=js"
export * from "./NotificationsArea.vue?vue&type=script&lang=js"
import style0 from "./NotificationsArea.vue?vue&type=style&index=0&id=65689a36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65689a36",
  null
  
)

export default component.exports